var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup570(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8944 24.8238H0.367188V23.3865H2.00614V23.0508C2.00614 19.5697 2.00614 16.0886 2.00614 12.6074C2.00614 10.276 2.00793 7.94465 2.00273 5.61326C2.00232 5.42778 2.02627 5.33322 2.24589 5.30662C2.71715 5.24953 3.18347 5.15168 3.66972 5.06742V0.312386H11.7148V3.7272C12.268 3.63736 12.7976 3.55134 13.3546 3.46088V6.89706H23.2582V23.391H24.8944L24.8944 24.8238ZM11.9053 5.16528C9.0812 5.63629 6.28005 6.10348 3.48196 6.57015V23.3737H5.31528V20.0974H10.0587V23.3714H11.9053L11.9053 5.16528ZM21.7803 23.3755V8.35029H13.3603V23.3755L21.7803 23.3755ZM10.2403 1.74567H5.12329V4.83013C6.84248 4.54338 8.54287 4.25976 10.2403 3.97663V1.74567ZM8.59359 23.3747V21.5404H6.7677V23.3747H8.59359Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0413 10.2V11.6192H8.62549V10.2H10.0413Z",
    fill: "#B9B9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 14.9219H8.62207V13.4952H10.0352V14.9219Z",
    fill: "#B9B9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32031 11.6223V10.1973H6.73934V11.6223H5.32031Z",
    fill: "#B9B9B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73665 14.9223H5.32227V13.4965H6.73665V14.9223Z",
    fill: "#B9B9B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61963 8.32476V6.90596H10.035V8.32476H8.61963Z",
    fill: "#B9B9B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31348 18.2101V16.8009H6.73347V18.2101H5.31348Z",
    fill: "#B9B9B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0367 16.7957V18.2065H8.62549V16.7957H10.0367Z",
    fill: "#B9B9B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2266 10.194H16.6377V11.6205H15.2266V10.194Z",
    fill: "#B9B9B9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6432 13.4954V14.9188H15.2256V13.4954H16.6432Z",
    fill: "#B9B9B9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5181 11.6197V10.1996H19.9382V11.6197H18.5181Z",
    fill: "#B9B9B9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9457 13.4979V14.9166H18.5254V13.4979H19.9457Z",
    fill: "#B9B9B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2261 16.7932H16.6334V18.209H15.2261V16.7932Z",
    fill: "#B9B9B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 16.7934H19.935V18.2089H18.5234V16.7934Z",
    fill: "#B9B9B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6343 21.512H15.2256V20.0946H16.6343V21.512Z",
    fill: "#B9B9B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9414 20.0972V21.5046H18.5254V20.0972H19.9414Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup570);
export default __webpack_public_path__ + "static/media/Group 570.fc1c593dd51c4333ed38855930bb5aa9.svg";
export { ForwardRef as ReactComponent };